module.exports = __webpack_public_path__ + "media/images/icons/quote-right-48f831921fec5999c7aa2f206f7afd9c.svg";